module.exports = __webpack_public_path__ + "static/media/YB5F12_4.53db0b1c.jpg";